import {
  EcommerceEmailsListAction,
  LOAD_ECOMMERCE_EMAILS_LIST,
  LOAD_ECOMMERCE_EMAILS_LIST_FAIL,
  LOAD_ECOMMERCE_EMAILS_LIST_SUCCESS,
  LoadEcommerceEmailsList,
  LoadEcommerceEmailsListFail,
  LoadEcommerceEmailsListSuccess,
} from "../actions";

export interface IEcommerceEmailsListEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceEmailsListState {
  entities: { [websiteId: number]: IEcommerceEmailsListEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceEmailsListState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceEmailsListState = initialState, action: EcommerceEmailsListAction): IEcommerceEmailsListState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_EMAILS_LIST:
      payload = (<LoadEcommerceEmailsList>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_EMAILS_LIST_SUCCESS:
      payload = (<LoadEcommerceEmailsListSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_EMAILS_LIST_FAIL:
      payload = (<LoadEcommerceEmailsListFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
